import React from 'react'
import {SuspenseWhileLoading} from '@oc/components'

const DasDiagnosticAdapters = React.lazy(async () => ({
    default: (await import('@oc/das-diagnostic/module')).DasDiagnosticAdaptersModule
}))

export function DasDiagnosticAdaptersComponent() {
    return <SuspenseWhileLoading LazyComponent={DasDiagnosticAdapters} />
}

const DasDiagnosticAdapterValues = React.lazy(async () => ({
    default: (await import('@oc/das-diagnostic/module')).DasDiagnosticAdapterValuesModule
}))

export function DasDiagnosticAdapterValuesComponent() {
    return <SuspenseWhileLoading LazyComponent={DasDiagnosticAdapterValues} />
}
